export interface ProductCategory {
  key: string;
  slug: string;
  label: string;
  navLabel: string;
  description: string;
}

// Keys match the `category` field stored on product documents. Slugs are the
// permanent, crawlable storefront URLs and should not be changed casually.
export const PRODUCT_CATEGORIES: ProductCategory[] = [
  { key: "bracelet", slug: "bracelet", label: "Bracelets", navLabel: "Bracelets", description: "Explore gemstone and spiritual bracelets selected for intention, everyday wear and meaningful gifting." },
  { key: "combo", slug: "combo", label: "Combo Bracelets", navLabel: "Combo Bracelets", description: "Discover thoughtfully paired bracelet combinations designed to make choosing complementary stones simple." },
  { key: "mala", slug: "mala", label: "Mala", navLabel: "Mala", description: "Shop malas for meditation, mantra practice and daily spiritual rituals, with clear product guidance." },
  { key: "rudraksha", slug: "rudraksha", label: "Rudraksha", navLabel: "Rudraksha", description: "Browse authentic Rudraksha products for prayer, practice and personal spiritual use." },
  { key: "gemstone", slug: "gemstone", label: "Gemstones", navLabel: "Gemstones", description: "Choose gemstones by origin, grade and carat with transparent specifications and pricing." },
  { key: "nakshatra", slug: "nakshatra", label: "Nakshatras", navLabel: "Nakshatras", description: "Explore products inspired by Vedic lunar constellations and astrology-informed traditions." },
  { key: "rasi", slug: "rasi", label: "Rasi Products", navLabel: "Rasi Products", description: "Explore gemstones, bracelets and spiritual products inspired by the twelve Rasi signs and Vedic astrology traditions." },
  { key: "yantra", slug: "yantra", label: "Yantras", navLabel: "Yantras", description: "Discover sacred geometric yantras chosen for worship spaces, meditation and traditional rituals." },
  { key: "pyrite", slug: "pyrite", label: "Pyrite", navLabel: "Pyrite", description: "Explore striking pyrite pieces for decor, gifting and crystal collections." },
  { key: "idol", slug: "idol", label: "Idols", navLabel: "Idols", description: "Find devotional idols for home temples, workspaces and thoughtful spiritual gifting." },
  { key: "others", slug: "others", label: "Other Spiritual Products", navLabel: "Products", description: "Browse more carefully selected spiritual products, ritual essentials and meaningful gifts." },
];

export const getProductCategory = (keyOrSlug?: string): ProductCategory | undefined => {
  const normalized = keyOrSlug?.trim().toLocaleLowerCase();
  if (!normalized) return undefined;
  return PRODUCT_CATEGORIES.find(
    (category) => category.key.toLocaleLowerCase() === normalized || category.slug.toLocaleLowerCase() === normalized,
  );
};

export const safelyDecodeCategorySlug = (value?: string): string => {
  if (!value) return "";
  try {
    return decodeURIComponent(value);
  } catch {
    return "";
  }
};

export const getCategoryPath = (keyOrSlug: string): string => {
  const category = getProductCategory(keyOrSlug);
  return category ? `/category/${category.slug}` : "/";
};

export const isCategorySlug = (slug?: string): boolean => Boolean(getProductCategory(slug));

export const categoryLabel = (key?: string): string =>
  getProductCategory(key)?.label ?? key ?? "—";
